import { createContext, useContext } from "react";

import { ProductListResponseType } from "@sellar-io/api-v2/types";

import { ItemDiscountFormSubmitType } from "../forms/ItemDiscountForm";

export type ConnectionProps = {
  buyerName: string;
  retailerId: number;
  connectionId: number;
};

export enum AddItemDiscountDialogPage {
  SEARCH,
  PRODUCT_ITEM_LIST,
  PRODUCT_ITEM_DISCOUNT,
}

export const AddItemDiscountDialogContext = createContext<
  | {
      searchQuery: string;
      setSearchQuery: (searchQuery: string) => void;
      onSubmit: (
        product: ItemDiscountFormSubmitType & { productItemId: number },
      ) => void;
      product?: ProductListResponseType[number];
      setProduct: (
        product: ProductListResponseType[number] | undefined,
      ) => void;
      productItem?: ProductListResponseType[number];
      setProductItem: (
        product: ProductListResponseType[number] | undefined,
      ) => void;
    }
  | undefined
>(undefined);

export const useAddItemDiscountDialogContext = () => {
  const context = useContext(AddItemDiscountDialogContext);
  if (context === undefined) {
    throw new Error(
      "useAddItemDiscountDialogContext must be within AddItemDiscountDialogContextProvider",
    );
  }

  return context;
};
